<template>
  <v-dialog
    :value="isSubscriptionEditorDrawerOpen"
    width="50%"
    @input="subscriptionEditorDrawerInput"
  >
    <v-card class="rounded-lg px-2">
      <v-card-title class="justify-center">
        <h2 class="title text_color">
          {{ $t("subscriptions.edit.title") }}
        </h2>
        <v-btn
          icon
          style="position: absolute; top: 14px; right: 20px;"
          @click="close"
        >
          <v-icon>
            close
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="mt-4">
        <component :is="subscriptionEditorByGateway" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import PaymentsWayEditor from "@/components/Subscriptions/Edit/Gateways/PaymentsWay";
import RecurrentPaymentsEditor from "@/components/Subscriptions/Edit/Gateways/RecurrentPaymentsDRB";

export default {
  name: "SubscriptionEditor",
  components: { PaymentsWayEditor, RecurrentPaymentsEditor },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      subscription: ({ transactions: { transaction } }) => transaction,
      isSubscriptionEditorDrawerOpen: ({
        transactions: { isSubscriptionEditorDrawerOpen }
      }) => isSubscriptionEditorDrawerOpen
    }),
    subscriptionEditorByGateway() {
      return this.getSubscriptionEditorComponent();
    }
  },
  methods: {
    ...mapMutations({
      setSubscriptionEditorDrawer: "transactions/setSubscriptionEditorDrawer"
    }),
    getSubscriptionEditorComponent() {
      const { gateway } = this.subscription;

      const PAYMENTS_WAY = "Bakery";
      const RECURRENT_PAYMENTS = "Recurrent Payments";

      // Defines which component will be rendered depending of the gateway of the subscription
      switch (gateway.gateway.name) {
        case PAYMENTS_WAY:
          return "PaymentsWayEditor";
        case RECURRENT_PAYMENTS:
          return "RecurrentPaymentsEditor";
        default:
          break;
      }
    },
    subscriptionEditorDrawerInput(arg) {
      if (!arg) {
        this.setSubscriptionEditorDrawer(false);
      }
    },
    close() {
      this.setSubscriptionEditorDrawer(false);
    }
  }
};
</script>

<style>
.text_color {
  color: #344054 !important;
}

body::-webkit-scrollbar {
  width: 1em;
}

body::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

body::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
}
</style>
